export const openBase64Pdf = (b64: string) => {
	try {
		const byteCharacters = atob(b64)
		const byteNumbers = new Array(byteCharacters.length)
		for (let i = 0; i < byteCharacters.length; i++) {
			byteNumbers[i] = byteCharacters.charCodeAt(i)
		}
		const byteArray = new Uint8Array(byteNumbers)
		const file = new Blob([byteArray], { type: 'application/pdf;base64' })
		const fileURL = URL.createObjectURL(file)

		const pdfWindow = window.open('')
		pdfWindow?.document.write(`<iframe width="100%" height="100%" src="${fileURL}"></iframe>`)
	} catch (error) {
		console.dir(error)
	}
}
